@keyframes skeleton-slide {
  from {
    left: -100px;
  }

  to {
    left: calc(100% + 100px);
  }
}

.rect {
  width: 300px;
  height: 60px;
  border-radius: 12px;
}

.skeletonContent {
  background-color: #eee;
  position: relative;
}

.skeletonContent::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 100%;
  box-shadow: 0 0 80px 20px #fff;
  animation: skeleton-slide 0.6s infinite ease-in-out;
}
